import { useUserContext } from '@nrdy-marketing-engine/server/src/user/context';
import { useCallback } from 'react';
import { Client } from '../../../@types/cart-state';
import { trackCartEvent, trackCartFailure } from '../../lib/track-service/track-cart';
import useCheckoutCompletionRouting from '../use-checkout-completion-routing';

export default function useOnSignIn({ setLoading, setError, onContinue }) {
  const { signInAndStore } = useUserContext();
  const { enableRoutingEffects } = useCheckoutCompletionRouting();

  const onFailure = useCallback(
    async ({ message }) => {
      setLoading(false);
      setError('email', { message });

      await trackCartFailure(
        'checkout_sign_in_failure',
        {
          clientUuid: null,
          error: message,
        },
        message
      );
    },
    [setError, setLoading]
  );

  const onSuccess = useCallback(
    async (client: Client) => {
      await trackCartEvent(
        'checkout_sign_in_success',
        {
          clientUuid: client?.uuid,
        },
        `Sign in${client?.hasMembership ? ' with membership' : ''}`
      );

      if (client.hasMembership) {
        enableRoutingEffects();
      } else {
        onContinue({ client });
      }
    },
    [onContinue, enableRoutingEffects]
  );

  const signIn = useCallback(
    async (client: Client) => {
      setLoading(true);

      await signInAndStore({ email: client.email, password: client.password })
        .then((data) => onSuccess(data as any))
        .catch((data) => onFailure(data));
    },
    [setLoading, onFailure, onSuccess, signInAndStore]
  );

  return signIn;
}
